import Swiper from "swiper";

import { Navigation, FreeMode, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".testimonial-slider");

  blocks.forEach((block) => {
    const slider = block.querySelector(".swiper");

    if (!slider) return;

    const trail = slider.querySelector(".swiper-wrapper");
    const prev = block.querySelector(".swiper-button-prev");
    const next = block.querySelector(".swiper-button-next");

    const hasProp = (prop, obj) =>
      Object.keys(obj).filter((key) => key === prop).length > 0;

    // Create a variable for data-autoplay on .swiper, if it exists true, false otherwise
    const hasAutoplay =
      hasProp("autoplay", slider.dataset) &&
      slider.dataset.autoplay !== "false";
    const overflowHidden = slider.classList.contains("hide-trail");

    const slidesPerView = hasProp("slidesPerView", slider.dataset)
      ? parseFloat(slider.dataset.slidesPerView)
      : 1.25;

    const slides = trail.querySelectorAll(".swiper-slide");

    if (!trail || !slides.length) {
      console.warn("El contenedor Swiper no se encontró en:", block);
      return;
    }

    const swiperConfig = {
      slidesPerView: 1.25,
      spaceBetween: "8px",
      centeredSlides: false,
      loop: false,
      speed: 800,
      allowTouchMove: true,
      rewind: true,
      ...(hasAutoplay && {
        autoplay: {
          delay: 1500,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        },
      }),

      navigation: {
        prevEl: prev,
        nextEl: next,
      },
      breakpoints: {
        768: {
          slidesPerView: slidesPerView,
          allowTouchMove: true,
          freeMode: {
            enabled: true,
            sticky: true,
            minimumVelocity: 0.1,
            freeModeMomentum: true,
          },
        },
      },
      modules: [Navigation, FreeMode, Autoplay],
    };

    const swiper = new Swiper(slider, swiperConfig);
  });
});
